var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"result-content"},[_c('div',{staticClass:"result-box"},[_c('div',{staticClass:"result-title"},[_vm._v(_vm._s(_vm.$t('sorry')))]),_c('div',{staticClass:"result-footer"},[_vm._v(_vm._s(_vm.$t('age-restrict')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }